export const themeType = Object.freeze({light: 0, dark: 1});

export const typo = {
  header: {
    h1: {
      fontSize: 60,
      fontWeight: 700,
      lineHeight: 36,
    },
    h2: {
      fontSize: 40,
      fontWeight: 700,
      lineHeight: 40,
    },
    h3: {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 40,
    },

  },
  subTitle: {
    s1: {
      fontSize: 20,
      fontWeight: 400,
      lineHeight: 40,
    },
  },
  body: {
    b1: {
      fontSize: 25,
      fontWeight: 700,
      lineHeight: 40,
    },
    b2: {
      fontSize: 20,
      fontWeight: 400,
      lineHeight: 40,
    },
    b3: {
      fontSize: 35,
      fontWeight: 700,
      lineHeight: 50,
    },
    b4: {
      fontSize: 28,
      fontWeight: 500,
      lineHeight: 40,
    },
    b5: {
      fontSize: 28,
      fontWeight: 700,
      lineHeight: 40,
    },
    b6: {
      fontSize: 15,
      fontWeight: 700,
      lineHeight: 50,
    },
    b7: {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: 28,
    },
    b8: {
      fontSize: 17,
      fontWeight: 700,
      lineHeight: 24,
    },
  },
  footer: {
    f1: {
      fontSize: 15,
      fontWeight: 700,
      lineHeight: 80,
    },
    f2: {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: 100,
    },
    f3: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: 100,},
  },
  caption: {
    c1: {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: 18,
    },
    c2: {
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 12,
    },
  },
};

export function color(theme){

    switch(theme){
        
        case themeType.dark:
            return{
                primary: {
                    p300: '#FFE8AD',
                    p400: '#FFD15C',
                    p500: '#FFD600',
                    p600: '#FFBA0D',
                    p700: '#FDAD2B', 
                }, 
                secondary: {
                    s300: '#656BAA',
                    s400: '#343C91',
                    s500: '#030D77',
                    s600: '#020A5A',
                    s700: '#01063C', 
                },
                grey: {
                    g50: '#FEFEFE',
                    g100: '#FDFDFD',
                    g200: '#F7F8F9',
                    g300: '#E9EBEE',
                    g400: '#C5C8CE',
                    g500: '#646F7C',
                    g600: '#374553',
                    g700: '#28323C', 
                    g800: '#161D24', 
                },
                base: {
                    background: '#FFFFFF',
                    modal: '#FFFFFF',
                    contents: '#FFFFFF',
                    line: '#F7F8F9',
                    borderThin: '#E9EBEE', 
                    borderThick: '#E9EBEE',
                },
                text: {
                    primary: '#374553',
                    secondary: '#646F7C',
                    placeholder: '#C5C8CE',
                },
                system: {
                    strong: '#FFD600',
                    warn: '#FF3C31',
                    green: '#00BC4B',
                },
            }
        case themeType.light :
        default:
            return {
                primary: {
                    p300: '#FFBF1C',
                    p400: '#FFC633',
                    p500: '#FFCF25',
                    p600: '#FFDB5C',
                    p700: '#FFEDAD', 
                }, 
                secondary: {
                    s300: '#09045A',
                    s400: '#0F067E',
                    s500: '#0D0197',
                    s600: '#222C9C',
                    s700: '#4A53B9', 
                },
                grey: {
                    g50: '#171B1C',
                    g00: '#1E2427',
                    g200: '#2E363A',
                    g300: '#41474C',
                    g400: '#5A6166',
                    g500: '#999FA4',
                    g600: '#C5C8CE',
                    g700: '#F7F8F9', 
                    g800: '#FDFDFD', 
                },
                base: {
                    background: '#171B1C',
                    modal: '#1E2427',
                    contents: '#171B1C',
                    line: '#000000',
                    borderThin: '#2E363A', 
                    borderThick: '#171B1C',
                },
                text: {
                    primary: '#F7F8F9',
                    secondary: '#C5C8CE',
                    placeholder: '#5A6166',
                },
                system: {
                    strong: '#FFCF25',
                    warn: '#FF5C53',
                    green: '#22AF5B',
                },
            } 
    }    
}